import { TextDisplay } from "lumir-back-office-ui/RmsTextDisplay";

const RecruitContents = ({
  title,
  jobDescription,
  recruitImg,
  positionPostType,
  stage,
  isMobile,
}) => {
  return (
    <div>
      <section className="mt-12 space-y-[40px]">
        {positionPostType === "IMAGE" ? (
          <div className="w-full h-full">
            <img
              src={recruitImg}
              alt={`${title} 공고 이미지`}
              className="w-full h-full object-cover"
            />
          </div>
        ) : (
          jobDescription.map((item, index) => (
            <div key={index} className={`space-y-8`}>
              <TextDisplay
                size={isMobile ? "md" : "lg"}
                textData={{
                  primary: item.title,
                }}
              />
              <div className="space-y-4">
                {item.description.map((desc, descIndex) => (
                  <p
                    key={descIndex}
                    className="typography-semantic-body-1-reading---regular"
                    dangerouslySetInnerHTML={{ __html: desc }}
                  />
                ))}
              </div>
            </div>
          ))
        )}
        {positionPostType !== "IMAGE" && (
          <div className="space-y-8">
            <TextDisplay
              size={isMobile ? "md" : "lg"}
              textData={{
                primary: stage?.title,
              }}
            />
            <TextDisplay
              size={isMobile ? "md" : "lg"}
              textData={{
                primary: stage?.description,
              }}
            />
          </div>
        )}
      </section>
    </div>
  );
};

export { RecruitContents };
